import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './modules/shared/store';
import * as serviceWorker from './serviceWorker';
import { I18nGate } from './config/i18n';
import ClientRoutesProvider from './config/clientRoutes/ClientRoutesContext';
import './app.css';
import {
  AppShell,
  BackendHealthCheck,
  NotistackProvider,
  privateRouteConfig,
  SettingsProvider,
  publicRouteConfig,
} from './modules/app';
import { PersistGate } from 'redux-persist/integration/react';

export const baseName = process.env.REACT_APP_BASE_PATH || '';
export const appName = process.env.REACT_APP_NAME || '';
export const appLogoSimple = process.env.REACT_APP_LOGO_SIMPLE;
export const currentEnv = process.env.REACT_APP_ENVIRONMENT;
export const appLogoFull = process.env.REACT_APP_LOGO_FULL;

document.title = appName;

ReactDOM.render(
  <BackendHealthCheck>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <SettingsProvider>
          <I18nGate loading={null}>
            <NotistackProvider>
              <ClientRoutesProvider
                publicRouteConfig={publicRouteConfig}
                privateRouteConfig={privateRouteConfig}
              >
                <Router basename={baseName}>
                  <AppShell />
                </Router>
              </ClientRoutesProvider>
            </NotistackProvider>
          </I18nGate>
        </SettingsProvider>
      </PersistGate>
    </Provider>
  </BackendHealthCheck>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
